import React from "react";
import { Link } from "react-router-dom";
import HomeCard from "./HomeCard";

const AnimationCard: React.FC = () => {
    return (
        <HomeCard>
            <h5 className="card-title">Animation</h5>
            <p>
                Use artificial intelligence to turn a video of your hand into an
                animation in Blender.
            </p>
            <Link to="/animation">Create Animation</Link>
        </HomeCard>
    );
};

export default AnimationCard;
